import * as _ from 'lodash'

const sanitizeId = (id: string) => {
  return `${id}`.replace(/[^a-zA-Z\d-]/g, '');
}

export const validateId = (id: string): boolean => {
  return sanitizeId(id) === id
}

export const validateAPIParams = (envId: string, resourceId: string, versionId: string|undefined, resourceType: string): boolean => {
  const versionIdIsOk = versionId ? validateNumber(versionId) : true
  return validateParam(resourceType) && versionIdIsOk && validateNumber(resourceId) && validateId(envId)
}

export const validateAPPParams = (env: string, resourceType: string, id: string, dashboardType: string): boolean => {
  return validateParam(resourceType) && validateParam(id) && validateParam(dashboardType) && validateId(env)
}

export const validateServerParams = (envId: string, resourceType: string, serverName: string, serverId: string, dashboardType: string): boolean => {
  return validateParam(dashboardType) && validateNumber(serverId) && validateParam(serverName) && validateParam(resourceType) && validateId(envId)
}

const allowedOrgIdsValues = ['all']
const allowedEnvIdsValues = ['production', 'sandbox', 'design']

export const validateReportsParams = (orgId: string, envId: string, from: string, to: string, selectedType: string): boolean => {
  const orgIsOk = validateId(orgId) || allowedOrgIdsValues.indexOf(orgId) !== -1
  const envIsOk = validateId(envId) || allowedEnvIdsValues.indexOf(envId) !== -1
  return validateParam(from) && validateParam(to) && validateParam(selectedType) && envIsOk && orgIsOk
}

export const validateAPILogPoint = (envId: string, apiId: string, versionId: string): boolean => {
  return validateNumber(apiId) && validateNumber(versionId) && validateId(envId)
}

export const validateAPPLogPoint = (envId: string, appId: string, targetId: string|undefined): boolean => {
  const targetIdIsOk = targetId ? validateParam(targetId) : true
  const appIdIsOk = validateNumber(appId) || validateParam(appId)
  return targetIdIsOk && appIdIsOk && validateId(envId)
}

export const validateAPPRawData = (envId: string, appId: string): boolean => {
  return validateParam(appId) && validateId(envId)
}

export const validateSettingsParams = (category: string, envId: string): boolean => {
  return validateParam(category) && validateId(envId)
}

export const validateParam = (value: string): boolean => {
  return ['\\', '\\..', '/', ':'].find( x => value.indexOf(x) > -1 ) === undefined
}

export const validateNumber = (value: string) => _.isNumber(+value) && !_.isNaN(+value)
